import React from 'react'
import congoBg from "../../assets/congo-bg.png"
import { Button, Modal } from 'antd'

function CongratulationsModal({ setStep, setIsCongoModalOpen, isCongoModalOpen, congoText }) {
    return (
        <div style={{ border: "1px solid red", height: "20vh", width: "50%" }}>

            <Modal
                open={isCongoModalOpen}
                onCancel={() => setIsCongoModalOpen(false)}
                footer={null}
                closeIcon={false}
                className='token-model'
                maskClosable={false}
                width={"80%"}
                centered={true}
                style={{}}
            >
                <div className='congo-header' style={{}} >Congratulations!</div>
                <div className='r-c-c' style={{ width: "100%", height: "", position: "relative", }}>
                    <div className='congo-bg' style={{}}><img className='full-img' src={congoBg} /></div>

                    <div className='congo-content' style={{}}>{congoText}</div>
                    <div className='r-c-c done-btn-learning' style={{ position: "absolute", bottom: "5%", width: "100%" }} ><Button onClick={() => { setStep(6) }} >Next</Button></div>
                </div>
            </Modal>
        </div>
    )
}

export default CongratulationsModal
